import PeopleIcon from '@mui/icons-material/People';

export const EmployeeIcon = PeopleIcon;
